/**
 * What is heating a container. Two real heat sources, not one flag: a Bunsen
 * burner under a tripod, and the squat spirit lamp a school bench actually
 * reaches for when it just needs a gentle flame (both appear in the reference
 * apparatus photos). 'none' is the absence of either.
 *
 * Which stand a burner can go under is a separate question — see
 * standTypes.ts's standAllowsBurner.
 */
export type BurnerType = 'none' | 'bunsen' | 'spirit-lamp';

/** What the picker offers. 'none' is the STORED absence of a burner, not a
 *  thing you place — you take a burner away by tapping the lit one again. */
export const BURNER_TYPES: BurnerType[] = ['bunsen', 'spirit-lamp'];

export const BURNER_LABELS: Record<BurnerType, string> = {
  none: 'No Burner',
  bunsen: 'Bunsen Burner',
  'spirit-lamp': 'Spirit Lamp',
};

export const BURNER_HINTS: Record<BurnerType, string> = {
  none: 'Nothing heating this container — the temperature scale stays at room.',
  bunsen: 'A gas burner with a tall barrel — the hot flame, and it reaches a clamped vessel.',
  'spirit-lamp': 'A squat alcohol lamp with a wick. A gentler flame, close to the bench.',
};
